import axios from './axios';

export default {
  signOut() {
    return axios.delete('/users/sign_out');
  },
  signIn(payload) {
    return axios.post('/users/sign_in', { user: payload });
  },
  signUp(payload) {
    return axios.post('/users', { user: payload });
  },
  me() {
    return axios.get('/users/me');
  },
  resetPassword({ password, token }) {
    return axios.put('/users/password', { user: { password, reset_password_token: token } });
  },
  sendResetPasswordInstructions(email) {
    return axios.post('/users/reset_password', { email });
  },
};
